angular.module('impactx.hierarchyselect').controller('HierarchySelectCtrl', [
    '$scope',
    '$filter',
    '$timeout',
    HierarchySelectCtrl]);

function HierarchySelectCtrl($scope, $filter, $timeout) {
    var self = this;

    $scope.currentNode = {
        entries: $scope.rootNode
    };
    $scope.searchText = "";
    $scope.zoomedNode = $scope.ngModel;

    $scope.getEntries = function () {
        if ($scope.ngModel) {
            $scope.searchText = $scope.ngModel.name;
        }
        else {
            $scope.searchText = '';
        }

        return $timeout(function () {
            return $scope.zoomedNode ? $scope.getNewList($scope.zoomedNode) : $scope.currentNode.entries;
        });
    };

    $scope.getNewList = function (node) {
        $scope.zoomedNode = null;
        return $scope.onNodeChange({selectedNode: node}).then(function (newRootNode) {
            $scope.currentNode = {
                entries: newRootNode
            };
            return $scope.currentNode.entries;
        });
    };

    $scope.zoomIntoNode = function (node, event) {
        $scope.zoomedNode = node;
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
    };

    $scope.zoomOutOfNode = function (node, event) {
        $scope.amountDropdownItems = self.MAX_AMOUNT_DROPDOWN_ITEMS;
        node.id = node.superId;
        $scope.zoomedNode = node;
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
    };

    $scope.onFocus = function () {
        $scope.searchText = "";
        $scope.storedModel = $scope.ngModel;
    };

    $scope.onBlur = function () {
        $scope.zoomedNode = $scope.ngModel ? $scope.ngModel : $scope.currentNode;
        if ($scope.ngModel) {
            $scope.searchText = $scope.ngModel.name;
        }
    };

    $scope.setSelectedNode = function (node) {
        if (node) {
            $scope.zoomedNode = node;
            $scope.getNewList(node, "");
            $scope.ngModel = node;
            if (angular.isFunction($scope.onItemChange)) {
                $scope.onItemChange({selectedNode: node});
            }
            angular.element('#' + $scope.inputName).blur();
        }
    };

    // we need this watcher to be able to differ between click in input and click on clear-icon
    $scope.$watch('mdAutocompleteCtrl.index', function (newValue, oldValue) {
            if (!angular.equals(newValue, oldValue)) {
                if ($scope.mdAutocompleteCtrl.index === 0 && $scope.mdAutocompleteCtrl.matches.length === 0) {
                    $scope.ngModel = undefined;
                    angular.element('#' + $scope.inputName).blur();
                    if (angular.isFunction($scope.onItemChange)) {
                        $scope.onItemChange();
                    }
                }
            }
        }
    );

    self.getNodeById = function (nodeId) {
        var newNode = {};
        if (nodeId) {
            angular.copy($filter('filter')($scope.rootNode, {id: nodeId})[0], newNode);
            return newNode;
        }
        else {
            return angular.copy({entries: $scope.rootNode}, newNode);
        }
    };

    self.openHierarchySelect = function () {
        $timeout(function () {
            angular.element('#' + $scope.inputName).focus();
        }, 0);
    }
}